import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { ShimmerPlaceHolder } from "@faire/retailer-visitor-shared/components/Animation/ShimmerPlaceHolder";
import { LoadingProductTileSkeleton } from "@faire/retailer-visitor-shared/components/LoadingProductTileSkeleton/LoadingProductTileSkeleton";
import { Column, Flex, Row } from "@faire/web--source/slate/Layout";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import React from "react";
import styled from "styled-components";
var NUM_TILES = 12;
var FILTER_PROPS = {
    height: "40px",
    borderRadius: "20px",
    width: "120px"
};
export var LoggedOutCategoryPageHeroBannerSkeleton = function() {
    var titleHeight = useResponsiveValue({
        mobileAndAbove: 32,
        tabletAndAbove: 76,
        desktopAndAbove: 38,
        xLargeAndAbove: 50
    });
    var titleWidth = useResponsiveValue({
        mobileAndAbove: 330,
        desktopAndAbove: 356,
        xLargeAndAbove: 510
    });
    return /*#__PURE__*/ _jsxs(LoadingWrapper, {
        children: [
            /*#__PURE__*/ _jsxs(BannerTextWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(StyledPlaceHolder, {
                        $height: titleHeight,
                        $width: titleWidth
                    }),
                    /*#__PURE__*/ _jsx(StyledPlaceHolder, {
                        $height: 26,
                        $width: titleWidth
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(LoadingImgSkeleton, {})
        ]
    });
};
export var LoggedOutCategoryPageLoadingSkeleton = function() {
    return /*#__PURE__*/ _jsxs("div", {
        "data-test-id": "logged-out-category-page-loading-skeleton",
        children: [
            /*#__PURE__*/ _jsx(LoggedOutCategoryPageHeroBannerSkeleton, {}),
            /*#__PURE__*/ _jsxs(Wrapper, {
                children: [
                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                        width: "240px",
                        height: getSpacing("5x")
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "2x"
                    }),
                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                        width: "100%",
                        height: {
                            mobileAndAbove: "250px",
                            tabletAndAbove: "300px",
                            desktopAndAbove: "350px"
                        }
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "2x"
                    }),
                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                        width: "150px",
                        height: getSpacing("4x")
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "2x"
                    }),
                    /*#__PURE__*/ _jsxs(FilterRow, {
                        children: [
                            /*#__PURE__*/ _jsx(LoadingSkeleton, _object_spread({}, FILTER_PROPS)),
                            /*#__PURE__*/ _jsx(Spacer, {
                                width: "2x"
                            }),
                            /*#__PURE__*/ _jsx(LoadingSkeleton, _object_spread({}, FILTER_PROPS))
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "2x"
                    }),
                    /*#__PURE__*/ _jsx(TileGrid, {
                        children: Array.from({
                            length: NUM_TILES
                        }).map(function(_, index) {
                            return /*#__PURE__*/ _jsx(LoadingProductTileSkeleton, {}, index);
                        })
                    })
                ]
            })
        ]
    });
};
var BannerTextWrapper = styled(Flex).attrs({
    direction: "column",
    justify: "space-between",
    align: "flex-start",
    gap: "3x"
}).withConfig({
    componentId: "sc-c3541ff2-0"
})([
    "flex-basis:50%;",
    "{flex-basis:672px;width:672px;}",
    "{padding:",
    ";}",
    "{padding:",
    ";}",
    "{padding:",
    ";}",
    "{padding:",
    ";}"
], responsiveMediaQueries.xxlarge, responsiveMediaQueries.xLargeAndAbove, getSpacing(133, "6x"), responsiveMediaQueries.desktop, getSpacing("10x", "6x"), responsiveMediaQueries.tablet, getSpacing("8x", "4x"), responsiveMediaQueries.mobile, getSpacing("3x", "2x"));
var LoadingWrapper = styled(Flex).attrs({
    direction: {
        mobileAndAbove: "column-reverse",
        tabletAndAbove: "row"
    },
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-c3541ff2-1"
})([
    "width:100%;background-color:",
    ";",
    "{height:390px;}",
    "{height:290px;}",
    "{height:318px;}",
    "{height:400px;}"
], Core.surface.subdued, responsiveMediaQueries.xxlarge, responsiveMediaQueries.desktopAndAbove, responsiveMediaQueries.tablet, responsiveMediaQueries.mobile);
var StyledPlaceHolder = styled(ShimmerPlaceHolder).withConfig({
    componentId: "sc-c3541ff2-2"
})([
    "background-color:",
    ";"
], Core.surface.inverse);
var LoadingImgSkeleton = styled(ShimmerPlaceHolder).withConfig({
    componentId: "sc-c3541ff2-3"
})([
    "width:100%;height:100%;flex-basis:50%;",
    "{flex-basis:100%;}background-color:",
    ";",
    "{max-height:176px;}"
], responsiveMediaQueries.xxlarge, Core.surface.muted, responsiveMediaQueries.mobile);
var TileGrid = styled.div.withConfig({
    componentId: "sc-c3541ff2-4"
})([
    "display:grid;grid-gap:",
    ";",
    "{grid-template-columns:repeat(2,2fr);}",
    "{grid-template-columns:repeat(4,4fr);}",
    "{grid-template-columns:repeat(5,5fr);}",
    "{grid-template-columns:repeat(6,6fr);}"
], getSpacing("2x"), responsiveMediaQueries.mobile, responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.desktopAndAbove, responsiveMediaQueries.xLargeAndAbove);
var FilterRow = styled(Row).withConfig({
    componentId: "sc-c3541ff2-5"
})([
    "overflow-x:hidden;"
]);
var Wrapper = styled(Column).withConfig({
    componentId: "sc-c3541ff2-6"
})([
    "max-width:1344px;margin:0 auto;padding:",
    ";"
], getSpacing("4x", "2x", 0, "2x"));
